import { addListener, removeListener } from "./event-listeners";

/* Asynchromously loads a stylesheet */
export function loadStylesheet(src: string): Promise<HTMLLinkElement> {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = src;
    link.media = "print";

    const onLoad = () => {
      link.media = "all";
      removeListener(link, "load", onLoad);
      resolve(link);
    };

    const onError = (ev: ErrorEvent) => {
      removeListener(link, "error", onError);
      reject(ev.error);
    };

    addListener(link, "load", onLoad);
    addListener(link, "error", onError);

    document.head.appendChild(link);
  });
}
